<template>
  <v-app id="preorder">
    <v-content>
      <v-container>
        <v-row align="center" justify="center" class="mt-8">
          <v-col cols="12" xl="8" lg="12" md="12" sm="12">
            <v-stepper v-model="e6" vertical class="bg-white-light">
              <v-row>
                <SteppiLogo class="logo mx-auto mt-4" />
              </v-row>

              <h2 class="text-center mt-2">Pre-order nu je Steppi!</h2>

              <v-alert v-if="!isHidden" outlined text type="success" border="left" elevation="1" class="ma-3">
                Bedankt,
                uw pre-order is geplaatst!
              </v-alert>

              <v-stepper-step :complete="e6 > 1" step="1">
                STAP 1:
                <small>Persoonsgegevens</small>
              </v-stepper-step>

              <v-stepper-content step="1">
                <v-card class="mb-8 mx-1" height="auto" elevation="1">
                  <div class="pa-4">
                    <v-container>
                        <h3 class="h-custom">Persoonlijk</h3>
                        <v-row>
                          <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field rounded prepend-icon="mdi-account-box" label="Voornaam"
                              :rules="[v => !!v || 'Voornaam is verplicht']" required outlined
                              v-model="customerData.first_name"></v-text-field>
                            <v-text-field rounded prepend-icon="mdi-account-box-outline"
                              :rules="[v => !!v || 'Achternaam is verplicht']" label="Achternaam" required outlined
                              v-model="customerData.last_name"></v-text-field>
                            <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                              transition="scale-transition" offset-y min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field rounded label="Geboortedatum" :rules="dateRules"
                                  prepend-icon="mdi-calendar" readonly v-on="on" v-model="customerData.birthdate"
                                  outlined></v-text-field>
                              </template>
                              <v-date-picker ref="picker" v-model="customerData.birthdate"
                                :max="new Date().toISOString().substr(0, 10)" min="1919-01-01" @change="save">
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field rounded prepend-icon="mdi-email-outline" label="Email" :rules="emailRules"
                              required outlined v-model="customerData.email"></v-text-field>
                            <v-text-field rounded type="text" prepend-icon="mdi-phone-in-talk"
                              :rules="phoneRules" label="Telefoonnummer" required
                              outlined v-model="customerData.phone"></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea rounded label="Opmerkingen"
                                        outlined v-model="remark"></v-textarea>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-card-actions class="mx-3 mt-3">
                          <div class="flex-grow-1"></div>
                          <v-btn color="primary" @click="e6 = 2, validate">Volgende</v-btn>
                        </v-card-actions>
                    </v-container>
                  </div>
                </v-card>
              </v-stepper-content>

              <v-stepper-step :complete="e6 > 2" step="2">
                STAP 2:
                <small>Algemene voorwaarden</small>
              </v-stepper-step>

              <v-stepper-content step="2">
                <v-card class="mb-8 mx-1" height="auto" elevation="0">
                  <div class="pa-4">
                    <AgvPrivacy @updateBtn="toggleBtn"></AgvPrivacy>
                  </div>
                </v-card>
                <v-divider></v-divider>
                <v-card-actions class="mx-3 mt-3">
                  <v-btn text @click="e6 = 1">Terug</v-btn>
                  <div class="flex-grow-1"></div>
                  <v-btn color="primary" @click="placeOrderToggle()" :disabled="abc == false">
                    Pre-order
                    plaatsen
                  </v-btn>
                </v-card-actions>
              </v-stepper-content>
            </v-stepper>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import SteppiLogo from "../../components/SteppiLogo/SteppiLogo";
  import AgvPrivacy from "../../components/AgvPrivacy/AgvPrivacy";
  import {
    mapActions,
    mapState
  } from "vuex";

  export default {
    name: "PreOrder",
    components: {
      SteppiLogo,
      AgvPrivacy,
    },
    props: {},
    mounted() {
    },
    computed: {

    },
    data: () => ({
      valid: false,
      emailRules: [
        v => !!v || "E-mail is verplicht",
        v => /.+@.+\..+/.test(v) || "E-mail is niet correct"
      ],
      dateRules: [v => !!v || "Datum is verplicht"],
      phoneRules: [
        v => !!v || 'Telefoonnummer is verplicht',
        v => /^[0-9]{9,15}$/.test(v) || 'Telefoon nummer is niet correct'
      ],
      lazy: false,
      e6: 1,
      dialog: false,
      isHidden: true,
      menu: false,
      abc: false,
      customerData: {
        first_name: null,
        last_name: null,
        birthdate: null,
        phone: null
      },

      remark: ''
    }),
    watch: {
      menu(val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
      }
    },
    methods: {
      ...mapActions("customer", ["_preOrder"]),
      save(date) {
        this.$refs.menu.save(date.toLocaleString());
      },
      toggleBtn(val) {
        this.abc = val;
      },
      placeOrderToggle() {
        this.customerData.consent = this.abc;
        const data = {
          customer: this.customerData,
          remark: this.remark
        };
        console.log(data);
        this._preOrder(data)
          .then(() => {
            this.isHidden = !this.isHidden;
            this.e6 = 3;
          })
          .catch(() => {
            alert("Er is iets mis gegaan, probeer de pagina te verversen");
          });
      },
    }
  };
</script>

<style src='./PreOrder.scss' scoped lang='scss'></style>
